import React from 'react'
import { Form, Input, Alert, Button, message } from 'admin-web-ui'
import { Store } from 'rc-field-form/lib/interface'
import { ApolloClient } from '@apollo/client'
import { useAsyncFn } from 'react-use'
import styled from 'styled-components'
import { uploadSigningCertificateFingerprint } from './upload-signing-certificate-fingerprint'
import { UploadSigningCertificateFingerprintInput } from '../../../../api'

const FooterContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 0 -24px -8px;
  padding: 18px 24px 0;
`

const StyledButton = styled(Button)`
  min-width: 112px;
`

const SubmitButton = styled(StyledButton)`
  margin-left: 12px;
`

interface Props {
  projectClient: ApolloClient<unknown>
  onSuccess: () => void
  onCancel: () => void
}

export const AndroidSigningCertificateForm: React.FC<Props> = (props) => {
  const { projectClient, onCancel, onSuccess } = props
  const [submitState, handleSubmit] = useAsyncFn(
    async (values?: Store) => {
      if (!values) {
        return undefined
      }

      await uploadSigningCertificateFingerprint(
        projectClient,
        values as UploadSigningCertificateFingerprintInput,
      )

      message.success('Fingerprint added!')
      onSuccess()
    },
    [projectClient],
  )

  return (
    <Form onFinish={handleSubmit} layout="vertical">
      <Form.Item
        name="fingerprint"
        label="Fingerprint"
        rules={[{ required: true, message: 'Please provide a fingerprint.' }]}
      >
        <Input type="text" placeholder="Paste in fingerprint" />
      </Form.Item>
      <Form.Item
        name="friendlyName"
        label="Label"
        rules={[{ required: true, message: 'Please provide a friendly name.' }]}
      >
        <Input
          type="text"
          placeholder="Give your certificate a friendly name"
        />
      </Form.Item>
      {submitState.error && (
        <Alert
          type="error"
          message="There was an error adding your fingerprint. Please try again."
        />
      )}
      <FooterContainer>
        <StyledButton
          onClick={onCancel}
          className="automation_AndroidSigningCertificateFormCancelButton"
          type="default"
          shape="round"
        >
          Cancel
        </StyledButton>
        <SubmitButton
          className="automation_AndroidSigningCertificateFormSubmitButton"
          type="primary"
          htmlType="submit"
          loading={submitState.loading}
          shape="round"
        >
          Add
        </SubmitButton>
      </FooterContainer>
    </Form>
  )
}
